//React
import React from "react";

//Redux
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
//Action
import { loadingSet } from '../action/uiAction';
import * as partnerAction from '../action/partnerAction';
import * as bestpartnerAction from '../action/bestpartnerAction';
import * as lightboxAction from '../action/lightboxAction';
import * as helpAction from '../action/helpAction';
import * as favoriteAction from '../action/favoriteAction';
import * as partnerOperationAction from '../action/partnerOperationAction';
import * as uiAction from '../action/uiAction';
//Material-ui
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import Box from '@material-ui/core/Box';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Chip from '@material-ui/core/Chip';
import Dialog from '@material-ui/core/Dialog';
//Add
import { LazyLoadImage } from 'react-lazy-load-image-component';
//Part
import PartUserName from './PartUserName';
import PartPartnerPost from './PartPartnerPost';
import PartPartnerQa from './PartPartnerQa';
import PartPartnerPersonality from './PartPartnerPersonality';
import PartCoupleIcon from './PartCoupleIcon';
import PartPageTitle from './PartPageTitle';
import PartCheckbox from './PartCheckbox';
//Img
import NoimgMen from '../img/user/noimg_men.jpg';
import NoimgWomen from '../img/user/noimg_women.jpg';
import Blank from '../img/blank/blank-1x1.gif';
//Icon
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import CloseIcon from '@material-ui/icons/Close';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

class Comp extends React.Component {

  constructor(props) {
		super(props);

    this.state = {
      point: 0,
      profile: null,
      photo: [],
      setting: null,
      keyword: null,
      favorite: null,
      tab: 'profile',

      conditionPhotoMain: false,
      conditionFavorite: false,
      conditionDialog: false,
    }
	}

  componentDidMount() {
    document.title = 'プロフィールのプレビュー - パートナーズ';
    window.scrollTo(0, 0);
  }

  _renderImgMain(data) {
    let restriction = data.mainRestriction;
    let img = null;

		if (data.main.uriCrop) {
			if (!this.state.conditionPhotoMain && restriction === 1) {
				img = (
					<div style={{position:'relative'}}>
            <LazyLoadImage
              src={ data.main.uriCropBlur }
              style={{width:"100%", height: "auto", boxSizing:'border-box'}}
              placeholder={<img src={Blank} style={{width:"100%", height: "auto",}} alt='' />}
              alt=''
            />

            <div
              style={{
                position:'absolute',
                top:0,
                left:0,
                height:"100%",
                width: "100%",
                display: 'flex',
                justifyContent:'center',
                alignItems:'center',
                backgroundColor:'rgba(0, 0, 0, 0.5)'
              }}
            >
              <div>
  							<div
                  style={{fontSize:'1.4em', fontWeight:'900', color:'#FFF'}}
                  onClick={ (event) => this.props.popoverOpen(event.currentTarget, 'メイン写真を公開している会員にだけ、メイン写真を公開する設定です。メイン写真が未掲載の会員にはボカシ加工のお写真が掲載されます。') }
                >
                  公開制限
                </div>
  							<div style={{fontSize:'0.9em', color:'#FFF'}}>あなたがメイン写真を掲載すると<br/>ボカシが解除されます</div>

              </div>
            </div>
					</div>
				)
			}
			else {
				img = (
          <div
            style={{cursor:'pointer',position:'relative'}}
            onClick={ () => this._lightboxOpen(data.uri) }
          >
            <LazyLoadImage
              src={ data.main.uriCrop }
              style={{width:"100%", height: "auto", boxSizing:'border-box'}}
              placeholder={<img src={Blank} style={{width:"100%", height: "auto",}} alt='' />}
              alt=''
            />
            <img
              src={Blank}
              style={{
                position:'absolute',
                left:0,
                top:0,
                width:'100%',
                height:'100%',
              }}
              alt=''
            />
          </div>
				)
			}
		}
		else {
      let uri;
      if (this.props.my.profile.userdata_sex === 'men') {
        uri = NoimgMen;
      }
      else {
        uri = NoimgWomen;
      }
			img = (
        <LazyLoadImage
          src={ uri }
          style={{width:"100%", height: "auto", boxSizing:'border-box'}}
          placeholder={<img src={Blank} style={{width:"100%", height: "auto",}} alt='' />}
          alt=''
        />
			)
		}
    return (
      <div id='photo_main_outer'>
        { img }
      </div>
    )
	}

  _renderImgSub(value, index, arr) {
    let secret = value.secret;
    let img;

		if (this.state.conditionFavorite === false && secret === 1) {
			img = (
				<div
          style={{position:'relative'}}
        >
          <LazyLoadImage
            src={ value.uriCropBlur }
            style={{width:"100%", height: "auto", boxSizing:'border-box'}}
            placeholder={<img src={Blank} style={{width:"100%", height: "auto",}} alt='' />}
            alt=''
          />
					<div
            style={{
              position:'absolute',
              top:0,
              left:0,
              height:"100%",
              width: "100%",
              display: 'flex',
              justifyContent:'center',
              alignItems:'center',
              backgroundColor:'rgba(0, 0, 0, 0.5)'
            }}
          >
            <span
              className='button_white'
              onClick={ (event) => this.props.popoverOpen(event.currentTarget, 'シークレット写真は「お相手の会員」が「あなた」をお気に入りに登録すると閲覧できます') }
            >
              <div
                style={{
                  display:'flex',
                  flexDirection:'row',
                  alignItems:'center',
                }}
              >
                <ExpandMoreIcon style={{fontSize:'0.8em'}} />
                <span style={{fontSize:'0.8em'}}>シークレット</span>
              </div>
            </span>
					</div>
				</div>
			)
		}
		else {
			img = (
				<div
          style={{cursor:'pointer',position:'relative'}}
          onClick={ () => this._lightboxOpen(value.uri) }
        >
          <LazyLoadImage
            src={ value.uriCrop }
            style={{width:"100%", height: "auto", boxSizing:'border-box'}}
            placeholder={<img src={Blank} style={{width:"100%", height: "auto",}} alt='' />}
            alt=''
          />
          <img
            src={Blank}
            style={{
              position:'absolute',
              left:0,
              top:0,
              width:'100%',
              height:'100%',
            }}
            alt=''
          />
				</div>
			)
		}

    return (
      <div
        key={index}
        className='box_outer'
      >
        <div
          className='box_inner round12'
        >
          { img }
        </div>
      </div>
    )
	}

  _lightboxOpen(selectUri) {
    let photoList = [];
    let photo = this.props.my.photo;

    if (photo.sub) {
      let subFilter;
      if (this.state.conditionFavorite === true) {
        subFilter = photo.sub;
      }
      else {
        subFilter = photo.sub.filter(item => item.secret === 0);
      }

      photoList = subFilter.map(function(value, index) {
        return {src: subFilter[index].uri};
      });
    }
    if (photo.main.uri) {
      if (this.state.conditionPhotoMain === true || photo.mainRestriction === 0) {
        photoList.unshift({src: photo.main.uri});
      }
    }

    let selectIndex = photoList.findIndex((v) => v.src === selectUri);
    this.props.lightboxOpen(photoList, selectIndex);

  }

  _tabChange(event, newValue) {
    this.setState({tab:newValue});
  }




  _qaQuestionAnsweredCountEdit(count) {
    let c = this.state.qaQuestionAnsweredCount + count;
    this.setState({qaQuestionAnsweredCount: c});
  }

  render() {
    let profile = this.props.my.profile;
    let photo = this.props.my.photo;
    let keyword = this.props.my.keyword;
    let personality = this.props.my.personality;


    return (
      <Box style={{maxWidth:'900px', margin:'auto'}} boxShadow={2}>
        <div style={{position:'fixed',top:'0',left:'0px',width:'100%' ,zIndex:'101'}}>
          <div style={{maxWidth:'900px', margin:'auto', background:'#FFF'}} className='shadow'>
            <div
              style={{
                display:'flex',
                flexDirection:'row',
                alignItems:'center',
                justifyContent: 'space-between',
              }}
            >
              <div>
                <IconButton
                  onClick={ () => this.props.history.push('/my/') }
                  >
                  <ArrowBackIosIcon />
                </IconButton>
                <span style={{fontSize:'1.1em',fontWeight:'bold'}}>プレビュー</span>
              </div>
              <div style={{marginRight:'5px'}}>
                <Button
                  variant="outlined"
                  color='primary'
                  onClick={ () => this.setState({conditionDialog: true}) }
                  size='small'
                >
                  お相手からの見え方
                </Button>
              </div>
            </div>
          </div>
        </div>

        <div
          style={{
            width:'100%',
            paddingTop:'40px',
            paddingBottom:'10px',
          }}
        >
          <PartPageTitle
            title={(
              <PartUserName
                data={{
                  name: profile.userdata_name,
                  sex: profile.userdata_sex,
                  size: '1.2em',
                }}
              />
            )}
          />

          {
            (this.props.my.setting.serviceStop === 1) ? (
              <div
                align='center'
                style={{margin:'5px'}}
              >
                <h3>{profile.userdata_name}さんは停止された為、プロフィールは表示できません</h3>
              </div>
            ):
            (
              <div>
                <div style={{textAlign:'center'}}>
                  <div style={{color:'#666', fontSize:'1.1em'}}>
                    {profile.userdata_age}才 {profile.userdata_prof_region} {profile.userdata_prof_region_detail}
                  </div>
                </div>
                <div style={{margin:'15px 0px'}} align='center'>
                  {
                    (this.props.notification.couple) && (
                      <PartCoupleIcon />
                    )
                  }

                  <div
                    style={{
                      display:'flex',
                      flexDirection:'row',
                      flexWrap: 'wrap',
                      textAlign:'center',
                      alignItems:'center',
                      justifyContent:'center',
                      margin:'5px',
                    }}
                  >
                    {
                      (profile.userdata_proof_person === 1) && (
                        <span
                          className='proof_icon'
                          onClick={ (event) => this.props.popoverOpen(event.currentTarget, '公的な証明書のお名前、生年月日でご本人様であることが確認済です') }
                        >
                          本人証明
                        </span>
                      )
                    }
                    {
                      (profile.userdata_proof_photo === 1) && (
                        <span
                          className='proof_icon'
                          onClick={ (event) => this.props.popoverOpen(event.currentTarget, 'メイン写真がご本人様のお写真であることが確認済です') }
                        >
                          写真証明
                        </span>
                      )
                    }
                    {
                      (profile.userdata_proof_income === 1) && (
                        <span
                          className='proof_icon'
                          onClick={ (event) => this.props.popoverOpen(event.currentTarget, '公的な書類でプロフィールの年収と昨年度の年収が一致していることが確認済です') }
                        >
                          収入証明
                        </span>
                      )
                    }
                    {
                      (profile.userdata_proof_single === 1) && (
                        <span
                          className='proof_icon'
                          onClick={ (event) => this.props.popoverOpen(event.currentTarget, '公的な証明書で独身者であることが公的な証明書で確認済です') }
                        >
                          独身証明
                        </span>
                      )
                    }
                    {
                      (profile.userdata_proof_credit === 1) && (
                        <span
                          className='proof_icon'
                          onClick={ (event) => this.props.popoverOpen(event.currentTarget, 'カード会社の与信情報やカード名義が本人であることが確認済です') }
                        >
                          クレジット証明
                        </span>
                      )
                    }

                  </div>
                </div>
                <div style={{textAlign:'center', position: 'relative'}}>
                  {
        						this._renderImgMain(photo)
        					}

                </div>
                <div align='center' style={{margin:'1px'}}>
                  <div id={'photo_sub_block'}>
                    {
          						(Array.isArray(photo.sub) === true) &&
          						photo.sub.map(
                        (value, index, arr) => this._renderImgSub(value, index, arr)
          						)
          					}
                  </div>
                </div>
                {
                  (profile.userdata_prof_partner_comment) && (
                    <div align='center' style={{margin:'15px'}}>
                      <Box
                        className='round12'
                        boxShadow={2}
                        style={{
                          display:'inline-block',
                          maxWidth:'400px',
                          margin:'auto',
                          padding:'10px',
                          background:'#fff',
                        }}>
                        <div style={{whiteSpace:'pre-line',textAlign:'left'}}>
                          {profile.userdata_prof_partner_comment}
                        </div>
                      </Box>
                    </div>
                  )
                }

                <div style={{marginTop:'15px'}}>
                  <Tabs
                    value={this.state.tab}
                    onChange={ (e, value) => this.setState({tab: value}) }
                    indicatorColor="primary"
                    centered
                  >
                    <Tab
                      value="profile"
                      label="プロフ"
                      style={{fontSize:'1.2em',fontWeight:'bold'}}
                    />
                    {
                      (profile.post_count > 0) && (
                        <Tab
                          value="post"
                          label="投稿"
                          style={{fontSize:'1.2em',fontWeight:'bold'}}
                        />
                      )
                    }
                    {
                      (profile.qa_question_count > 0 || profile.qa_answer_count > 0 ) && (
                        <Tab
                          value="qa"
                          label="Q&A"
                          style={{fontSize:'1.2em',fontWeight:'bold'}}
                          wrapped
                        />
                      )
                    }
                    {
                      (personality.type16) && (
                        <Tab
                          value='cha'
                          label="性格"
                          style={{fontSize:'1.2em',fontWeight:'bold'}}
                          wrapped
                        />
                      )
                    }
                  </Tabs>
                </div>
                <div>
                  <div style={{borderTop:'1px solid #CCC'}}>
                    {
                      (this.state.tab === 'profile') &&
                      <div className='profile_block'>
                        <div className='col2'>
                          <Box
                            id='myProfileUserBox'
                            className='round12'
                            boxShadow={2}
                            style={{
                              background:'#FFF',
                              margin:'15px'
                            }}
                          >
                            <div
                              style={{
                                padding:'10px',
                                display:'flex',
                                flexDirection:'row',
                                justifyContent:'space-between',
                              }}
                            >
                              <h2>
                                プロフィール
                              </h2>
                            </div>
                            <table className='profileTable'>
                              <tbody>
                                <tr>
                                  <td className='title'><div className='text'>年齢</div></td>
                                  <td className='value'>{profile.userdata_age}才</td>
                                </tr>
                                <tr>
                                  <td className='title'><div className='text'>地域</div></td>
                                  <td className='value'>{profile.userdata_prof_region} {profile.userdata_prof_region_detail}</td>
                                </tr>
                                <tr>
                                  <td className='title'><div className='text'>出身</div></td>
                                  <td className='value'>{profile.userdata_prof_birthplace} {profile.userdata_prof_birthplace_detail}</td>
                                </tr>
                                <tr>
                                  <td className='title'><div className='text'>続柄</div></td>
                                  <td className='value'>{profile.userdata_prof_relationship}</td>
                                </tr>
                                <tr>
                                  <td className='title'><div className='text'>仕事</div></td>
                                  <td className='value'>{profile.userdata_prof_job}</td>
                                </tr>
                                <tr>
                                  <td className='title'><div className='text'>休日</div></td>
                                  <td className='value'>{profile.userdata_prof_holiday}</td>
                                </tr>
                                <tr>
                                  <td className='title'><div className='text'>年収</div></td>
                                  <td className='value'>{profile.userdata_prof_income}</td>
                                </tr>
                                <tr>
                                  <td className='title'><div className='text'>学歴</div></td>
                                  <td className='value'>{profile.userdata_prof_academic}</td>
                                </tr>
                                <tr>
                                  <td className='title'><div className='text'>宗教</div></td>
                                  <td className='value'>{profile.userdata_prof_religion}</td>
                                </tr>
                                <tr>
                                  <td className='title'><div className='text'>体型</div></td>
                                  <td className='value'>{profile.userdata_prof_style}</td>
                                </tr>
                                <tr>
                                  <td className='title'><div className='text'>身長</div></td>
                                  <td className='value'>{profile.userdata_prof_height}cm</td>
                                </tr>
                                <tr>
                                  <td className='title'><div className='text'>交際希望</div></td>
                                  <td className='value'>{profile.userdata_prof_association}</td>
                                </tr>
                                <tr>
                                  <td className='title'><div className='text'>結婚歴</div></td>
                                  <td className='value'>{profile.userdata_prof_marriage}</td>
                                </tr>
                                <tr>
                                  <td className='title'><div className='text'>生活</div></td>
                                  <td className='value'>{profile.userdata_prof_lifestyle}</td>
                                </tr>
                                <tr>
                                  <td className='title'><div className='text'>子供</div></td>
                                  <td className='value'>{profile.userdata_prof_child}</td>
                                </tr>
                                <tr>
                                  <td className='title'><div className='text'>ペット</div></td>
                                  <td className='value'>{profile.userdata_prof_pet}</td>
                                </tr>
                                <tr>
                                  <td className='title'><div className='text'>住居</div></td>
                                  <td className='value'>{profile.userdata_prof_house}</td>
                                </tr>
                                <tr>
                                  <td className='title'><div className='text'>車</div></td>
                                  <td className='value'>{profile.userdata_prof_car}</td>
                                  <td className='collation'></td>
                                </tr>
                                <tr>
                                  <td className='title'><div className='text'>タバコ</div></td>
                                  <td className='value'>{profile.userdata_prof_smorking}</td>
                                </tr>
                                <tr>
                                  <td className='title'><div className='text'>お酒</div></td>
                                  <td className='value'>{profile.userdata_prof_drinking}</td>
                                </tr>
                                <tr>
                                  <td className='title'><div className='text'>ギャンブル</div></td>
                                  <td className='value'>{profile.userdata_prof_gambling}</td>
                                </tr>
                                <tr>
                                  <td className='title'><div className='text'>血液型</div></td>
                                  <td className='value'>{profile.userdata_prof_blood}</td>
                                </tr>
                                <tr>
                                  <td className='title'><div className='text'>星座</div></td>
                                  <td className='value'>{profile.userdata_prof_constellation}</td>
                                </tr>
                              </tbody>
                            </table>
                          </Box>

                          <Box
                            id='myProfilePartnerBox'
                            className='round12'
                            boxShadow={2}
                            style={{
                              background:'#FFF',
                              margin:'15px'
                            }}
                          >
                            <div
                              style={{
                                padding:'10px',
                                display:'flex',
                                flexDirection:'row',
                                justifyContent:'space-between',
                              }}
                            >
                              <h2>
                                パートナーへの希望
                              </h2>
                            </div>

                            <table className='profileTable'>
                              <tbody>
                                <tr>
                                  <td className='title'>
                                    <div className='text'>年齢</div>
                                    {
                                      (profile.userdata_prof_partner_age_important === 1) &&
                                      <span className='importantIcon'>重要</span>
                                    }
                                  </td>
                                  <td className='value'>{profile.userdata_prof_partner_age_low} 〜 {profile.userdata_prof_partner_age_high}才</td>
                                </tr>
                                <tr>
                                  <td className='title'>
                                    <div className='text'>地域</div>
                                    {
                                      (profile.userdata_prof_partner_region_important === 1) &&
                                      <span className='importantIcon'>重要</span>
                                    }
                                  </td>
                                  <td className='value'>{profile.userdata_prof_partner_region}</td>
                                </tr>
                                <tr>
                                  <td className='title'>
                                    <div className='text'>仕事</div>
                                    {
                                      (profile.userdata_prof_partner_job_important === 1) &&
                                      <span className='importantIcon'>重要</span>
                                    }
                                  </td>
                                  <td className='value'>{profile.userdata_prof_partner_job}</td>
                                </tr>
                                <tr>
                                  <td className='title'>
                                    <div className='text'>年収</div>
                                    {
                                      (profile.userdata_prof_partner_income_important === 1) &&
                                      <span className='importantIcon'>重要</span>
                                    }
                                  </td>
                                  <td className='value'>{profile.userdata_prof_partner_income.replace(/,/g, '\n')}</td>
                                </tr>
                                <tr>
                                  <td className='title'>
                                    <div className='text'>学歴</div>
                                    {
                                      (profile.userdata_prof_partner_academic_important === 1) &&
                                      <span className='importantIcon'>重要</span>
                                    }
                                  </td>
                                  <td className='value'>{profile.userdata_prof_partner_academic}</td>
                                </tr>
                                <tr>
                                  <td className='title'>
                                    <div className='text'>体型</div>
                                    {
                                      (profile.userdata_prof_partner_style_important === 1) &&
                                      <span className='importantIcon'>重要</span>
                                    }
                                  </td>
                                  <td className='value'>{profile.userdata_prof_partner_style}</td>
                                </tr>
                                <tr>
                                  <td className='title'>
                                    <div className='text'>身長</div>
                                    {
                                      (profile.userdata_prof_partner_height_important === 1) &&
                                      <span className='importantIcon'>重要</span>
                                    }
                                  </td>
                                  <td className='value'>{profile.userdata_prof_partner_height_low} 〜 {profile.userdata_prof_partner_height_high}cm</td>
                                </tr>
                                <tr>
                                  <td className='title'>
                                    <div className='text'>交際希望</div>
                                    {
                                      (profile.userdata_prof_partner_association_important  === 1) &&
                                      <span className='importantIcon'>重要</span>
                                    }
                                  </td>
                                  <td className='value'>{profile.userdata_prof_partner_association}</td>
                                </tr>
                                <tr>
                                  <td className='title'>
                                    <div className='text'>結婚歴</div>
                                    {
                                      (profile.userdata_prof_partner_marriage_important === 1) &&
                                      <span className='importantIcon'>重要</span>
                                    }
                                  </td>
                                  <td className='value'>{profile.userdata_prof_partner_marriage}</td>
                                </tr>
                                <tr>
                                  <td className='title'>
                                    <div className='text'>生活</div>
                                    {
                                      (profile.userdata_prof_partner_lifestyle_important === 1) &&
                                      <span className='importantIcon'>重要</span>
                                    }
                                  </td>
                                  <td className='value'>{profile.userdata_prof_partner_lifestyle}</td>
                                </tr>
                                <tr>
                                  <td className='title'>
                                    <div className='text'>子供</div>
                                    {
                                      (profile.userdata_prof_partner_child_important === 1) &&
                                      <span className='importantIcon'>重要</span>
                                    }
                                  </td>
                                  <td className='value'>{profile.userdata_prof_partner_child}</td>
                                </tr>
                                <tr>
                                  <td className='title'>
                                    <div className='text'>ペット</div>
                                    {
                                      (profile.userdata_prof_partner_pet_important === 1) &&
                                      <span className='importantIcon'>重要</span>
                                    }
                                  </td>
                                  <td className='value'>{profile.userdata_prof_partner_pet}</td>
                                </tr>
                                <tr>
                                  <td className='title'>
                                    <div className='text'>タバコ</div>
                                    {
                                      (profile.userdata_prof_partner_smorking_important === 1) &&
                                      <span className='importantIcon'>重要</span>
                                    }
                                  </td>
                                  <td className='value'>{profile.userdata_prof_partner_smorking}</td>
                                </tr>
                                <tr>
                                  <td className='title'>
                                    <div className='text'>お酒</div>
                                    {
                                      (profile.userdata_prof_partner_drinking_important === 1) &&
                                      <span className='importantIcon'>重要</span>
                                    }
                                  </td>
                                  <td className='value'>{profile.userdata_prof_partner_drinking}</td>
                                </tr>
                                <tr>
                                  <td className='title'>
                                    <div className='text'>ギャンブル</div>
                                    {
                                      (profile.userdata_prof_partner_gambling_important === 1) &&
                                      <span className='importantIcon'>重要</span>
                                    }
                                  </td>
                                  <td className='value'>{profile.userdata_prof_partner_gambling}</td>
                                </tr>
                              </tbody>
                            </table>
                          </Box>
                        </div>


                        <div className='col2'>
                          <div align='center' style={{margin:'15px'}}>
                            <Box
                              className='round12'
                              boxShadow={2}
                              style={{
                                margin:'auto',
                                padding:'10px',
                                background:'#fff',
                                textAlign:'left',
                              }}
                            >
                              <h2 style={{textAlign:'center'}}>
                                自己紹介
                              </h2>
                              <div style={{whiteSpace:'pre-line'}}>
                                {profile.userdata_prof_comment}
                              </div>
                            </Box>
                          </div>
                          {
                            (keyword.length > 0) && (
                              <div align='center' style={{margin:'15px'}}>
                                <Box
                                  className='round12'
                                  boxShadow={2}
                                  style={{
                                    margin:'auto',
                                    padding:'10px',
                                    background:'#fff',
                                    textAlign:'left',
                                  }}
                                >
                                  <h2 style={{textAlign:'center'}}>
                                    キーワード
                                  </h2>
                                  <div>
                                    {
                                      keyword.map(
                                        (value, index, arr) => {
                                          return (
                                            <Chip
                                              key={index}
                                              label={ value.text }
                                              variant="outlined"
                                              style={{margin:'3px'}}
                                            />
                                          )
                                        }
                                      )
                                    }
                                  </div>
                                </Box>
                              </div>
                            )
                          }
                          {
                            (
                              profile.userdata_want_proof_person === 1 ||
                              profile.userdata_want_proof_photo === 1 ||
                              profile.userdata_want_proof_income === 1 ||
                              profile.userdata_want_proof_single === 1
                            ) && (
                              <div align='center' style={{margin:'15px'}}>
                                <Box
                                  className='round12'
                                  boxShadow={2}
                                  style={{
                                    margin:'auto',
                                    padding:'10px',
                                    background:'#fff',
                                    textAlign:'left',
                                  }}
                                >
                                  <h2 style={{textAlign:'center'}}>
                                    希望する証明書
                                  </h2>
                                  <div>
                                    {
                                      (profile.userdata_want_proof_person === 1) && (
                                        <span className='proof_icon'>本人証明</span>
                                      )
                                    }
                                    {
                                      (profile.userdata_want_proof_photo === 1) && (
                                        <span className='proof_icon'>写真証明</span>
                                      )
                                    }
                                    {
                                      (profile.userdata_want_proof_income === 1) && (
                                        <span className='proof_icon'>収入証明</span>
                                      )
                                    }
                                    {
                                      (profile.userdata_want_proof_single === 1) && (
                                        <span className='proof_icon'>独身証明</span>
                                      )
                                    }
                                  </div>
                                </Box>
                              </div>
                            )
                          }
                        </div>
                        <div style={{clear:'both'}}></div>
                      </div>
                    }
                    {
                      (this.state.tab === 'post') && (
                        <div
                          className='post_block'
                          style={{maxWidth:'600px',margin:'auto',}}
                        >
                          <PartPartnerPost
                            pic={this.props.auth.uic}
                            postCount={profile.post_count}
                          />
                        </div>
                      )
                    }
                    {
                      (this.state.tab === 'qa') && (
                        <div
                          className='qa_block'
                          style={{maxWidth:'600px',margin:'auto',}}
                        >
                          <PartPartnerQa
                            pic={this.props.auth.uic}
                            qaQuestionCount={profile.qa_question_count}
                            qaQuestionAnsweredCount={0}
                            qaAnswerCount={profile.qa_answer_count}
                            qaQuestionAnsweredCountEdit={ (count) => this._qaQuestionAnsweredCountEdit(count) }
                            tab={ (profile.qa_question_count > 0 ? 'question' : 'answer') }
                          />
                        </div>
                      )
                    }
                    {
                      (this.state.tab === 'cha') &&
                      <div
                        className='cha_block'
                        style={{maxWidth:'600px',margin:'auto',}}
                      >
                        <PartPartnerPersonality
                          pic={this.props.auth.uic}
                        />
                      </div>
                    }
                  </div>
                </div>

              </div>
            )

          }

        </div>

        <Dialog
          open={this.state.conditionDialog}
          maxWidth='xs'
          onClose={ () => this.setState({conditionDialog: false}) }
        >
          <div
            style={{
              display:'flex',
              flexDirection:'row',
              alignItems:'center',
              justifyContent:'space-between',
            }}
          >
            <div style={{fontSize:'1.1em',fontWeight:'bold',margin:'15px'}}>
              見え方の設定
            </div>
            <IconButton
              onClick={ () => this.setState({conditionDialog: false}) }
            >
              <CloseIcon/>
            </IconButton>
          </div>
          <div style={{margin:'5px'}}>
            <div style={{padding:'5px',fontSize:'0.9em',color:'#666'}}>
              閲覧する会員の状態を変更してプレビューできます
            </div>
            <div style={{padding:'5px'}}>
              <PartCheckbox
                value={(this.state.conditionPhotoMain) ? false : true}
                checked={this.state.conditionPhotoMain}
                click={ (e) => this.setState({conditionPhotoMain: e }) }
              >
                メイン写真を掲載している会員
              </PartCheckbox>
              <div style={{fontSize:'0.9em'}}>公開制限のメイン写真が公開されます</div>
            </div>
            <div style={{padding:'5px'}}>
              <PartCheckbox
                value={(this.state.conditionFavorite) ? false : true}
                checked={this.state.conditionFavorite}
                click={ (e) => this.setState({conditionFavorite: e }) }
              >
                あなたがお気に入り登録した会員
              </PartCheckbox>
              <div style={{fontSize:'0.9em'}}>シークレット写真が公開されます</div>
            </div>
          </div>

  			</Dialog>
      </Box>
    )


  }
}


const mapStateToProps = (state) => {
	return {
		notification: state.notification,
    auth: state.auth,
    my: state.my,
	}
};

const mapDispatchToProps = (dispatch) => {
	return bindActionCreators({
    loadingSet,
    ...partnerAction,
    ...favoriteAction,
    ...bestpartnerAction,
    ...lightboxAction,
    ...helpAction,
    ...partnerOperationAction,
    ...uiAction,
	}, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Comp);
